/**
 * Redux action creator.
 * Returns an action object to set the window tab bar to a desired state.
 * @param {boolean} show Whether to show the tab bar.
 * @returns {Object} Redux action object.
 * @example
 * const dispatch = useDispatch();
 * dispatch(toggleWindowTabBar(true));
 *  @deprecated
 */
function toggleWindowTabBar(show) {
	return {
		type: "SET_WINDOW_TAB_BAR_ENABLED",
		payload: show
	};
}

/**
 * Redux action creator.
 * Returns an action object to set the window sidebar to a desired state.
 * @param {boolean} show Whether to show the sidebar.
 * @returns {Object} Redux action object.
 * @example
 * const dispatch = useDispatch();
 * dispatch(toggleWindowSidebar(true));
 * @deprecated
 */
function toggleWindowSidebar(show) {
	return {
		type: "SET_WINDOW_SIDEBAR_ENABLED",
		payload: show
	};
}

export { toggleWindowTabBar, toggleWindowSidebar };
